export default "__VITE_ASSET__CYkRCwWM__"